import {CardBrand, OperationType, TransactionStatus} from "./transaction";

//TransactionStatus
const transactionStatusTranslations: Record<TransactionStatus | string, string> = {
  [TransactionStatus.approved]: 'aprobada',
  [TransactionStatus.rejected]: 'rechazada',
  [TransactionStatus.failed]: 'fallida',
  [TransactionStatus.reversed]: 'reversada',
};

export const translateTransactionStatus = (status: TransactionStatus | string): string => {
  if (status in transactionStatusTranslations) {
    return transactionStatusTranslations[status]
  }
  return status.toString()
}

//OperationType
const transactionOperationTypeTranslations: Record<OperationType | string, string> = {
  [OperationType.payment]: 'pago',
  [OperationType.refund]: 'devolución',
  [OperationType.annulment]: 'anulación',
};

export const translateOperationType = (type: OperationType | string): string => {
  if (type in transactionOperationTypeTranslations) {
    return transactionOperationTypeTranslations[type]
  }
  return type.toString()
}

//CardBrand
const transactionCardBrandTranslations: Record<CardBrand | string, string> = {
  [CardBrand.visa]: 'visa',
  [CardBrand.mastercard]: 'mastercard',
  [CardBrand.amex]: 'american express',
  [CardBrand.wuzi]: 'wuzi',
  [CardBrand.otras]: 'otras',
};

export const translateCardBrand = (brand: CardBrand | string): string => {
  if (brand in transactionCardBrandTranslations) {
    return transactionCardBrandTranslations[brand]
  }

  return brand.toString()
}

export const capitalizeEachWord = (sentence: string): string => {
  return sentence
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};



